import { EnglishArabicDTO } from "bnsights-control-library"
export class SectorModel
{
      Id:number
      IDEncrypted:string
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      DepartmentsCount :number
}
     